import React, { useEffect, useState } from "react";
import {
  Space,
  Button,
  Input,
  Form,
  notification,
  InputNumber,
  Switch,
  Card,
  Upload,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { updateCourseAction } from "../../redux/actions/courseActions";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import queryString from "query-string";
import { viewSpecificCourse } from "../../redux/actions/courseActions";
import { CloseOutlined, CheckOutlined } from "@ant-design/icons";
const { TextArea } = Input;
const { REACT_APP_EDITOR_KEY: apiKey } = process.env;

// import { Upload, message, Button } from 'antd';

const EditCourse = ({
  viewSpecificCourseAction,
  updateCourseAction,
  courseState,
  location,
}) => {
  const history = useHistory();

  const [loading, setLoading] = useState(false);

  const { name, description, insp1, insp2, insp3, duration, visible } =
    queryString.parse(location.search);

  const [isPublic, setIsPublic] = useState(visible);

  console.log("myvisible", JSON.parse(isPublic));
  const onFinish = (courseData) => {
    setLoading(true);
    const payload = {
      ...courseData,
      oldName: name,
      isVisible: isPublic,
    };

    updateCourseAction(payload);
  };

  const normFile = (e) => {
    console.log("Upload event:", e);

    if (Array.isArray(e)) {
      return e;
    }

    return e && e.fileList;
  };

  // const getSpecificCourse = async () => {
  //   const cData = await viewSpecificCourse(name);
  //   console.log(cData.data);
  //   setCourseData(cData);
  //   // courseData=cData;

  //   console.log(courseData);
  // };

  useEffect(() => {
    if (!name) {
      history.push("/dashboard");
    }
    if (courseState.updateCourseData) {
      setLoading(false);
      notification.success({ message: "Course updated successfully" });
      history.push(`/dashboard`);

      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }
    if (courseState.updateCourseError) {
      setLoading(false);
      notification.error({
        message: courseState.updateCourseError.error,
      });
    }
  }, [courseState]);

  return (
    <Card className="container-center" style={{ background: "white" }}>
      <div className="container-dft-margin">
        <h2>
          <strong>Edit course</strong>
        </h2>
        <Form
          layout="vertical"
          hideRequiredMark
          className="mb-4"
          initialValues={{
            courseName: name,
            courseDescription: description,
            insp1: insp1,
            insp2: insp2,
            insp3: insp3,
            duration: duration,
          }}
          onFinish={onFinish}
        >
          <Form.Item
            label="Course Name"
            name="courseName"
            rules={[{ required: true, message: "Please provide course name" }]}
          >
            <Input size="large" type="text" placeholder="Course name" />
          </Form.Item>
          <Form.Item
            label="Course Description"
            name="courseDescription"
            rules={[
              {
                max: 150,
                message: "Description should be of 150 chars maximum",
              },
            ]}
          >
            <TextArea
              rows={4}
              placeholder="Course description"
              defaultValue={description}
            />
          </Form.Item>

          <Form.Item label="Inspirations:" name="insp1">
            <Input size="large" type="text" placeholder="" />
          </Form.Item>
          <Form.Item name="insp2">
            <Input size="large" type="text" placeholder="" />
          </Form.Item>

          <div style={{ display: "flex", width: "100%" }}>
            <Form.Item name="insp3">
              <Input size="large" type="text" placeholder="" />
            </Form.Item>

            <Form.Item
              name="upload"
              label="Upload"
              valuePropName="fileList"
              getValueFromEvent={normFile}
              extra="longgggggggggggggggggggggggggggggggggg"
            >
              <Upload name="logo" action="/upload.do" listType="picture">
                <Button icon={<UploadOutlined />}>Click to upload</Button>
              </Upload>
            </Form.Item>

            <Form.Item
              label="Course Duration in Weeks"
              name="duration"
              style={{ width: "50%" }}
            >
              <InputNumber size="large" min={0} max={100} />
            </Form.Item>
            <Form.Item
              label="Publish Course Public"
              name="visible"
              valuePropName={isPublic}
            >
              <Switch
                checkedChildren={<CheckOutlined />}
                unCheckedChildren={<CloseOutlined />}
                defaultChecked={JSON.parse(visible)}
                onChange={(checked) => {
                  setIsPublic(checked);
                  console.log("checked", checked);
                }}
              />
            </Form.Item>
          </div>

          <Space style={{ marginTop: 16 }}>
            <Button
              type="primary"
              size="large"
              loading={loading}
              htmlType="submit"
              // onClick={showModal}
            >
              Update
            </Button>
          </Space>
        </Form>
      </div>
    </Card>
  );
};

const mapStateToProps = (state) => {
  return { courseState: state.courses.updateCourse };
};

export default connect(mapStateToProps, { updateCourseAction })(EditCourse);
